(function (app, ng) {
    app.constant("industryStandardsConstant",
        {
            cumulative: {
                responseRate: {
                    name: 'responseRate',
                    displayName: 'Response <br> Rate',
                    icon: 'fig-mailbox-open',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                noShowRate: {
                    name: 'noShowRate',
                    displayName: 'No-show <br> Rate',
                    icon: 'fig-cancel',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                appointmentSetRate: {
                    name: 'appointmentSetRate',
                    displayName: 'Appointment <br> Set Rate',
                    icon: 'fig-calendar-check',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                persistencyRate: {
                    name: 'persistencyRate',
                    displayName: 'Persistency <br> Rate',
                    icon: 'fig-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                closeRate: {
                    name: 'closeRate',
                    displayName: 'Close <br> Rate',
                    icon: 'fig-thumb-up',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                roi: {
                    name: 'roi',
                    displayName: 'ROI',
                    icon: 'fig-dollar-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                averageCaseSize: {
                    name: 'averageCaseSize',
                    displayName: 'Average <br> Case Size',
                    icon: 'fig-briefcase',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                }
            },
            clientEvents: {
                responseRate: {
                    name: 'responseRate',
                    displayName: 'Response <br> Rate',
                    icon: 'fig-mailbox-open',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                noShowRate: {
                    name: 'noShowRate',
                    displayName: 'No-show <br> Rate',
                    icon: 'fig-cancel',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                appointmentSetRate: {
                    name: 'appointmentSetRate',
                    displayName: 'Appointment <br> Set Rate',
                    icon: 'fig-calendar-check',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                persistencyRate: {
                    name: 'persistencyRate',
                    displayName: 'Persistency <br> Rate',
                    icon: 'fig-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                closeRate: {
                    name: 'closeRate',
                    displayName: 'Close <br> Rate',
                    icon: 'fig-thumb-up',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                roi: {
                    name: 'roi',
                    displayName: 'ROI',
                    icon: 'fig-dollar-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                averageCaseSize: {
                    name: 'averageCaseSize',
                    displayName: 'Average <br> Case Size',
                    icon: 'fig-briefcase',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                }
            },
            collegeClasses: {
                responseRate: {
                    name: 'responseRate',
                    displayName: 'Response <br> Rate',
                    icon: 'fig-mailbox-open',
                    value: 0, //if standard is a single value
                    lowerBound: .1, //if standard is a range
                    upperBound: .3
                },
                noShowRate: {
                    name: 'noShowRate',
                    displayName: 'No-show <br> Rate',
                    icon: 'fig-cancel',
                    value: 10, //if standard is a single value
                    lowerBound: 0, //if standard is a range
                    upperBound: 0
                },
                appointmentSetRate: {
                    name: 'appointmentSetRate',
                    displayName: 'Appointment <br> Set Rate',
                    icon: 'fig-calendar-check',
                    value: 50,
                    lowerBound: 0,
                    upperBound: 0
                },
                persistencyRate: {
                    name: 'persistencyRate',
                    displayName: 'Persistency <br> Rate',
                    icon: 'fig-arrow-return',
                    value: 90,
                    lowerBound: 0,
                    upperBound: 0
                },
                closeRate: {
                    name: 'closeRate',
                    displayName: 'Close <br> Rate',
                    icon: 'fig-thumb-up',
                    value: 30,
                    lowerBound: 0,
                    upperBound: 0
                },
                roi: {
                    name: 'roi',
                    displayName: 'ROI',
                    icon: 'fig-dollar-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                averageCaseSize: {
                    name: 'averageCaseSize',
                    displayName: 'Average <br> Case Size',
                    icon: 'fig-briefcase',
                    value: 250000,
                    lowerBound: 0,
                    upperBound: 0
                }
            },
            dinnerSeminars: {
                responseRate: {
                    name: 'responseRate',
                    displayName: 'Response <br> Rate',
                    icon: 'fig-mailbox-open',
                    value: 0, //if standard is a single value
                    lowerBound: .4, //if standard is a range
                    upperBound: 1
                },
                noShowRate: {
                    name: 'noShowRate',
                    displayName: 'No-show <br> Rate',
                    icon: 'fig-cancel',
                    value: 0, //if standard is a single value
                    lowerBound: 15, //if standard is a range
                    upperBound: 20
                },
                appointmentSetRate: {
                    name: 'appointmentSetRate',
                    displayName: 'Appointment <br> Set Rate',
                    icon: 'fig-calendar-check',
                    value: 50,
                    lowerBound: 0,
                    upperBound: 0
                },
                persistencyRate: {
                    name: 'persistencyRate',
                    displayName: 'Persistency Rate',
                    icon: 'fig-arrow-return',
                    value: 90,
                    lowerBound: 0,
                    upperBound: 0
                },
                closeRate: {
                    name: 'closeRate',
                    displayName: 'Close <br> Rate',
                    icon: 'fig-thumb-up',
                    value: 30,
                    lowerBound: 0,
                    upperBound: 0
                },
                roi: {
                    name: 'roi',
                    displayName: 'ROI',
                    icon: 'fig-dollar-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                averageCaseSize: {
                    name: 'averageCaseSize',
                    displayName: 'Average <br> Case Size',
                    icon: 'fig-briefcase',
                    value: 150000,
                    lowerBound: 0,
                    upperBound: 0
                }
            },
            sSSeminars: {
                responseRate: {
                    name: 'responseRate',
                    displayName: 'Response <br> Rate',
                    icon: 'fig-mailbox-open',
                    value: 0, //if standard is a single value
                    lowerBound: .4, //if standard is a range
                    upperBound: 1
                },
                noShowRate: {
                    name: 'noShowRate',
                    displayName: 'No-show <br> Rate',
                    icon: 'fig-cancel',
                    value: 0, //if standard is a single value
                    lowerBound: 15, //if standard is a range
                    upperBound: 20
                },
                appointmentSetRate: {
                    name: 'appointmentSetRate',
                    displayName: 'Appointment <br> Set Rate',
                    icon: 'fig-calendar-check',
                    value: 50,
                    lowerBound: 0,
                    upperBound: 0
                },
                persistencyRate: {
                    name: 'persistencyRate',
                    displayName: 'Persistency Rate',
                    icon: 'fig-arrow-return',
                    value: 90,
                    lowerBound: 0,
                    upperBound: 0
                },
                closeRate: {
                    name: 'closeRate',
                    displayName: 'Close <br> Rate',
                    icon: 'fig-thumb-up',
                    value: 30,
                    lowerBound: 0,
                    upperBound: 0
                },
                roi: {
                    name: 'roi',
                    displayName: 'ROI',
                    icon: 'fig-dollar-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                averageCaseSize: {
                    name: 'averageCaseSize',
                    displayName: 'Average <br> Case Size',
                    icon: 'fig-briefcase',
                    value: 150000,
                    lowerBound: 0,
                    upperBound: 0
                }
            },
            publicEduWorkshops: {
                responseRate: {
                    name: 'responseRate',
                    displayName: 'Response <br> Rate',
                    icon: 'fig-mailbox-open',
                    value: 0, //if standard is a single value
                    lowerBound: .4, //if standard is a range
                    upperBound: 1
                },
                noShowRate: {
                    name: 'noShowRate',
                    displayName: 'No-show <br> Rate',
                    icon: 'fig-cancel',
                    value: 0, //if standard is a single value
                    lowerBound: 15, //if standard is a range
                    upperBound: 20
                },
                appointmentSetRate: {
                    name: 'appointmentSetRate',
                    displayName: 'Appointment <br> Set Rate',
                    icon: 'fig-calendar-check',
                    value: 50,
                    lowerBound: 0,
                    upperBound: 0
                },
                persistencyRate: {
                    name: 'persistencyRate',
                    displayName: 'Persistency Rate',
                    icon: 'fig-arrow-return',
                    value: 90,
                    lowerBound: 0,
                    upperBound: 0
                },
                closeRate: {
                    name: 'closeRate',
                    displayName: 'Close <br> Rate',
                    icon: 'fig-thumb-up',
                    value: 30,
                    lowerBound: 0,
                    upperBound: 0
                },
                roi: {
                    name: 'roi',
                    displayName: 'ROI',
                    icon: 'fig-dollar-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                averageCaseSize: {
                    name: 'averageCaseSize',
                    displayName: 'Average <br> Case Size',
                    icon: 'fig-briefcase',
                    value: 150000,
                    lowerBound: 0,
                    upperBound: 0
                }
            },
            referrals: {
                responseRate: {
                    name: 'responseRate',
                    displayName: 'Response <br> Rate',
                    icon: 'fig-mailbox-open',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                noShowRate: {
                    name: 'noShowRate',
                    displayName: 'No-show <br> Rate',
                    icon: 'fig-cancel',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                appointmentSetRate: {
                    name: 'appointmentSetRate',
                    displayName: 'Appointment <br> Set Rate',
                    icon: 'fig-calendar-check',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                persistencyRate: {
                    name: 'persistencyRate',
                    displayName: 'Persistency <br> Rate',
                    icon: 'fig-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                closeRate: {
                    name: 'closeRate',
                    displayName: 'Close <br> Rate',
                    icon: 'fig-thumb-up',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                roi: {
                    name: 'roi',
                    displayName: 'ROI',
                    icon: 'fig-dollar-arrow-return',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                },
                averageCaseSize: {
                    name: 'averageCaseSize',
                    displayName: 'Average <br> Case Size',
                    icon: 'fig-briefcase',
                    value: null, //if standard is a single value
                    lowerBound: null, //if standard is a range
                    upperBound: null
                }
            }
        }
    );
})(window.app, window.angular);